/*
 * @Author: changcheng
 * @LastEditTime: 2024-08-26 17:12:02
 */
import {
  CourseUpload,
  CourseStatistics,
  CreateBatch,
  HelpRelaApply,
  Expertbase,
  UserManagement,
  SetObjectAudit,
  DataManager,
  CourseReview,
  CourseList,
  LecturerManage,
  ConfirmAssistance,
  RelationshipEdit,
  MyCourse,
  BaseInfo,
  UpdatePassWord,
  SetExamineMethod,
  TrainObject,
  TrainObjectOutPutRecord,
  SetRegMethod,
  OverAllOverView,
  Labelmanagement,
  LearnSettings,
  Approval,
  AdminManage,
  SpecialClassification,
  CaseDisussion,
  PublishNews,
  EditNews,
  ColumnManager,
  CreateOperateUser,
  LiveCategory,
  LiveConfiguration,
} from "@root/pages/index";
// 默认的考试管理前端模版
const defaultExamManageComponent = <div id="examPaper"></div>;
export const routerAuthorizonMap = new Map([
  ["examPaper", defaultExamManageComponent],
  ["userManagement", <UserManagement />],
  ["courseStatistics", <CourseStatistics />],
  ["courseUpload", <CourseUpload />],
  ["createBatch", <CreateBatch />],
  ["helpRelaApply", <HelpRelaApply />],
  ["expertbase", <Expertbase />],
  ["setObjectAudit", <SetObjectAudit />],
  ["DataManager", <DataManager />],
  ["CourseReview", <CourseReview />],
  ["CourseList", <CourseList />],
  ["LecturerManage", <LecturerManage />],
  ["confirmAssistance", <ConfirmAssistance />],
  ["relationshipEdit", <RelationshipEdit />],
  ["UpdatePassWord", <UpdatePassWord />],
  ["MyCourse", <MyCourse />],
  ["BaseInfo", <BaseInfo />],
  ["SetExamineMethod", <SetExamineMethod />],
  ["TrainObject", <TrainObject />],
  ["TrainObjectOutPutRecord", <TrainObjectOutPutRecord />],
  ["SetRegMethod", <SetRegMethod />],
  ["OverAllOverview", <OverAllOverView />],
  ["Labelmanagement", <Labelmanagement />],
  ["LearnSettings", <LearnSettings />],
  ["Approval", <Approval />],
  ["adminManage", <AdminManage />],
  ["specialClassification", <SpecialClassification />],
  ["caseDiscussion", <CaseDisussion />],
  ["EditNews", <EditNews />],
  ["PublishNews", <PublishNews />],
  ["ColumnManager", <ColumnManager />],
  ["CreateOperateUser", <CreateOperateUser />],
  ["LiveCategory", <LiveCategory />],
  ["LiveConfiguration", <LiveConfiguration />],
]);
